import { get } from "lodash";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { GET_IMAGES, LIST_BUDGET_NEWS } from "../../apiConst";
import SelectDropdown from "../../Common/SelectDropdown";
import { taskStatusOptions } from "../../utils";
import { postRequest, putRequest } from "../interceptor/interceptor";
import FullScreenLoader from "../Loader/FullScreenLoader";
import { FaListUl, FaThLarge, FaTasks } from "react-icons/fa";
import { VscTasklist } from "react-icons/vsc";

import { Button } from "@mui/material";
import { IoMdAdd, IoMdSend } from "react-icons/io";
import { resetClipboardStubOnView } from "@testing-library/user-event/dist/cjs/utils/index.js";
import ImagesList from "./ImageGallery";
import AddImage from "./AddImage";
import ImageGallery from "./ImageGallery";

export default function Images() {
  const [isLoading, setIsLoading] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(rowsPerPage);
  const [tableRowsData, setTableRowsData] = useState([]);
  const { role } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const {
    register,
    getValues,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({});

  useEffect(() => {
    fetchListData();
  }, []);
  const fetchListData = (pg = 1, size = 10, search = "", searchKey = null) => {
    setIsLoading(true);

    let payload = {
      filter: {},
      sortOrder: -1,
      page: pg,
      pageSize: size,
    };

    const { searchField } = getValues();
    const key = searchKey ? searchKey : searchField;
    if (key && search) {
      payload.filter[key] = search;
    }
    postRequest(GET_IMAGES, payload)
      .then((res) => {
        console.log("res", res);
        const { result, totalCount } = res.data;
        setTableRowsData(result || []);
        setTotalCount(totalCount || result?.length);
        setIsLoading(false);
        setIsDisplay(true);
      })
      .catch(() => {
        setIsLoading(false);
        setTableRowsData([]);
        setTotalCount(0);
      });
  };

  return (
    <>
      {isLoading && <FullScreenLoader />}
      <AddImage  getListData={fetchListData}/>
      <ImageGallery
        tableRowsData={tableRowsData}
        getListData={fetchListData}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        totalCount={totalCount}
        page={page}
        setPage={setPage}
        register={register}
        errors={errors}
      />
    </>
  );
}
